import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="background"></div>
      <div className="container">
        <h1>Privacy Policy for Folivana Audio</h1>
        <p>Last updated: 19 Jan 2025</p>
        <h2>1. Introduction</h2>
        <p>Welcome to Folivana Audio. We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Discord bot.</p>
        <h2>2. Information We Collect</h2>
        <p>We collect information that you provide directly to us when you use Folivana Audio. This may include:</p>
        <ul>
          <li>Discord User ID</li>
          <li>Server ID where the bot is used</li>
          <li>Commands you use with the bot</li>
          <li>Music preferences and playlists</li>
        </ul>
        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Provide, maintain, and improve our services</li>
          <li>Respond to your requests and inquiries</li>
          <li>Analyze usage patterns to enhance user experience</li>
          <li>Prevent fraudulent use of our services</li>
        </ul>
        <h2>4. Sharing of Your Information</h2>
        <p>We do not sell or rent your personal information to third parties. We may share your information in the following situations:</p>
        <ul>
          <li>With your consent</li>
          <li>To comply with legal obligations</li>
          <li>To protect our rights, privacy, safety, or property</li>
        </ul>
        <h2>5. Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized or unlawful processing, accidental loss, destruction, or damage.</p>
        <h2>6. Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. You can exercise these rights by contacting us directly.</p>
        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
        <h2>8. Contact Us</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at: <a href='https://discord.gg/HYrhjHgFgQ'>Support Server</a></p>
      </div>
    </div>
  );
}

export default App;
